/** Final document / OG title: page topic, brand at the end. */
export function formatDocumentTitle(topic: string) {
  const t = topic.trim()
  return t ? `${t} | vodi4ka.com` : 'vodi4ka.com'
}

const DEFAULT_MAX_LENGTH = 60
const MIN_WORD_BOUNDARY_RATIO = 1 / 3

/**
 * Product `<title>` only: no brand prefix; trim to maxLength at a word boundary.
 * Does not append an ellipsis — H1 still shows the full product name.
 */
export function truncateProductDocumentTitle(
  name: string,
  maxLength = DEFAULT_MAX_LENGTH,
): string {
  const t = name.trim()
  if (t.length <= maxLength) return t

  const window = t.slice(0, maxLength)
  const minBoundary = Math.max(1, Math.floor(maxLength * MIN_WORD_BOUNDARY_RATIO))
  const lastSpace = window.lastIndexOf(' ')
  if (lastSpace >= minBoundary) {
    return window.slice(0, lastSpace).trimEnd()
  }
  return window
}
